import axios from '@/store/api.js'

function setSearchParameters (filter, queryitem, state, rootState) {
    let q = {
        parameter: {}
    }

    // Paging
    q.pageSize = filter.pageSize || state.pageSize

    // Sorting
    q.orderByDescending = filter.orderByDescending

    q.filter = {}

    // Save filtering
    q.filter.saveFilter = filter.saveFilter

    // Filter id
    q.filter.filterId = filter.filterId

    // Filter name
    q.filter.filterName = filter.filterName

    // KPI
    if (filter.kpi || state.filters.kpi) {
        if (queryitem === 'request' && (filter.kpi === 'enquiriesNoResponsible' || state.filters.kpi === 'enquiriesNoResponsible')) {
            // KPI: Enquiry, No responsible
            q.kpiFilter = 'noCaseWorker'
        } else if (queryitem === 'task' && (filter.kpi === 'tasksReadyForApproval' || state.filters.kpi === 'tasksReadyForApproval')) {
            // KPI: Ready for approval
            q.kpiFilter = 'approveReady'
        } else if (queryitem === 'requisition' && (filter.kpi === 'requisitionsOverdue' || state.filters.kpi === 'requisitionsOverdue')) {
            // KPI: Overdue
            q.kpiFilter = 'overdue'
        } else if (queryitem === 'requisition' && (filter.kpi === 'requisitionsOpen' || state.filters.kpi === 'requisitionsOpen')) {
            // KPI: Not closed
            q.kpiFilter = 'notClosed'
        }
    }

    // Supplytypes
    q.parameter.whereBusinessAreaTypeIdList = state.filters.supplyType

    if (queryitem === 'request') {
        filter.pageNumber = state.activePages.enquiries
        advancedRequestQuery(q, filter, state)
    }
    if (queryitem === 'task') {
        filter.pageNumber = state.activePages.tasks
        advancedTaskQuery(q, filter, state)
    }
    if (queryitem === 'requisition') {
        filter.pageNumber = state.activePages.requisitions
        advancedRequisitionQuery(q, filter, state)
    }
    if (queryitem === 'routine') {
        filter.pageNumber = state.activePages.routines
        advancedRoutineQuery(q, filter, state)
    }
    if (queryitem === 'template') {
        filter.pageNumber = state.activePages.templates
        advancedTemplateQuery(q, filter, state)
    }

    if (queryitem === 'taskEnquiry') {
        q = {
            parameter: {}
        }

        q.pageSize = filter.pageSize || state.pageSize
        q.pageNumber = filter.pageNumber || state.activePageContextView
        q.orderByColumnName = filter.orderByColumnName || state.currentTaskSimpleOrderByColumnName
        q.orderByDescending = filter.orderByDescending || state.currentTaskOrderByDescending

        // Include routines
        q.parameter.includeRoutines = true

        // Task ?
        if (filter.whereTaskId) {
            q.parameter.whereTaskId = filter.whereTaskId
        } else {
            if (filter.whereDistanceWithinFromRequestId) {
                state.advancedFilterTaskEnquiry.whereDistanceWithinFromRequestId = filter.whereDistanceWithinFromRequestId
                state.advancedFilterTaskEnquiry.whereCurrentLocationPointWkt = null
            } else if (filter.whereCurrentLocationPointWkt) {
                state.advancedFilterTaskEnquiry.whereDistanceWithinFromRequestId = null
                state.advancedFilterTaskEnquiry.whereCurrentLocationPointWkt = filter.whereCurrentLocationPointWkt
            } else if (!filter.whereDistanceWithinFromRequestId && !filter.whereCurrentLocationPointWkt && !filter.pageNumber) {
                state.advancedFilterTaskEnquiry.whereDistanceWithinFromRequestId = null
                state.advancedFilterTaskEnquiry.whereCurrentLocationPointWkt = null
            }
            q.parameter.whereDistanceWithinFromRequestId = state.advancedFilterTaskEnquiry.whereDistanceWithinFromRequestId
            q.parameter.whereCurrentLocationPointWkt = state.advancedFilterTaskEnquiry.whereCurrentLocationPointWkt
            q.parameter.whereCurrentLocationWithinDistance = filter.whereCurrentLocationWithinDistance || state.advancedFilterTaskEnquiry.whereCurrentLocationWithinDistance
            if (filter.whereCurrentLocationWithinDistance) {
                state.advancedFilterTaskEnquiry.whereCurrentLocationWithinDistance = filter.whereCurrentLocationWithinDistance
            }
        }

        // Closed
        q.parameter.whereIsClosed = true
    }

    return q
}

function advancedRequestQuery (q, filter, state) {
    state.activePages.enquiries = filter.pageNumber || 1
    q.pageNumber = filter.pageNumber || 1
    q.orderByColumnName = filter.orderByColumnName || state.currentEnquiryOrderByColumnName
    q.orderByDescending = filter.orderByDescending || state.currentEnquiryOrderByDescending

    // Closed
    q.parameter.whereIsClosed = filter.whereIsClosed || state.filters.enquiries.showClosed

    // Responsible
    if (filter.whereOwnerUserIdList) {
        q.parameter.whereOwnerUserIdList = filter.whereOwnerUserIdList.length === 0 ? null : filter.whereOwnerUserIdList
    } else if (state.filters.enquiries.responsible && state.filters.enquiries.responsible.length > 0) {
        q.parameter.whereOwnerUserIdList = state.filters.enquiries.responsible
    } else {
        q.parameter.whereOwnerUserIdList = null
    }

    // From date
    if (filter.whereFromDate) {
        const fromDate = new Date(filter.whereFromDate)
        q.parameter.whereFromDate = new Date(fromDate.setHours(1, 0, 0)).toISOString()
    } else if (state.filters.enquiries.createdDate.from) {
        q.parameter.whereFromDate = state.filters.enquiries.createdDate.from
    } else {
        q.parameter.whereFromDate = null
    }

    // To date
    if (filter.whereToDate) {
        const toDate = new Date(filter.whereToDate)
        q.parameter.whereToDate = new Date(toDate.setHours(23, 59, 59)).toISOString()
    } else if (state.filters.enquiries.createdDate.to) {
        q.parameter.whereToDate = state.filters.enquiries.createdDate.to
    } else {
        q.parameter.whereToDate = null
    }

    // Address
    if (filter.whereLikeOccurrenceAddress) {
        q.parameter.whereLikeOccurrenceAddress = filter.whereLikeOccurrenceAddress
    } else if (state.filters.address) {
        q.parameter.whereLikeOccurrenceAddress = state.filters.address
    } else {
        q.parameter.whereLikeOccurrenceAddress = null
    }

    // Problem type
    if (filter.whereProblemTypeIdList) {
        q.parameter.whereProblemTypeIdList = filter.whereProblemTypeIdList.length === 0 ? null : filter.whereProblemTypeIdList
    } else if (state.filters.enquiries.problemType && state.filters.enquiries.problemType.length > 0) {
        q.parameter.whereProblemTypeIdList = state.filters.enquiries.problemType
    } else {
        q.parameter.whereProblemTypeIdList = null
    }

    // Client type
    if (filter.whereClientTypeIdList) {
        q.parameter.whereClientTypeIdList = filter.whereClientTypeIdList.length === 0 ? null : filter.whereClientTypeIdList
    } else if (state.filters.enquiries.contactType && state.filters.enquiries.contactType.length > 0) {
        q.parameter.whereClientTypeIdList = state.filters.enquiries.contactType
    } else {
        q.parameter.whereClientTypeIdList = null
    }

    return q
}

function advancedTaskQuery (q, filter, state) {
    state.activePages.tasks = filter.pageNumber || 1
    q.pageNumber = filter.pageNumber || 1
    q.parameter.pageNumber = filter.pageNumber || 1
    q.orderByColumnName = filter.orderByColumnName || state.currentTaskOrderByColumnName
    q.orderByDescending = filter.orderByDescending || state.currentTaskOrderByDescending

    // Name
    if (filter.whereLikeTaskName) {
        q.parameter.whereLikeTaskName = filter.whereLikeTaskName
    } else if (state.filters.tasks.name) {
        q.parameter.whereLikeTaskName = state.filters.tasks.name
    } else {
        q.parameter.whereLikeTaskName = null
    }

    // Address
    if (filter.whereLikeAddress) {
        q.parameter.whereLikeAddress = filter.whereLikeAddress
    } else if (state.filters.address) {
        q.parameter.whereLikeAddress = state.filters.address
    } else {
        q.parameter.whereLikeAddress = null
    }

    // Responsible
    if (filter.whereOwnerUserIdList) {
        q.parameter.whereOwnerUserIdList = filter.whereOwnerUserIdList.length === 0 ? null : filter.whereOwnerUserIdList
    } else if (state.filters.tasks.responsible && state.filters.tasks.responsible.length > 0) {
        q.parameter.whereOwnerUserIdList = state.filters.tasks.responsible
    } else {
        q.parameter.whereOwnerUserIdList = null
    }

    // Closed
    q.parameter.whereIsClosed = filter.whereIsClosed || state.filters.tasks.showClosed

    // Sent to user
    if (filter.whereSentToUserIdList) {
        q.parameter.whereSentToUserIdList = filter.whereSentToUserIdList.length === 0 ? null : filter.whereSentToUserIdList
    } else if (state.filters.tasks.contact && state.filters.tasks.contact.length > 0) {
        q.parameter.whereSentToUserIdList = state.filters.tasks.contact
    } else {
        q.parameter.whereSentToUserIdList = null
    }

    // Sent to organization
    if (filter.whereSentToOrganizationIdList) {
        q.parameter.whereSentToOrganizationIdList = filter.whereSentToOrganizationIdList.length === 0 ? null : filter.whereSentToOrganizationIdList
    } else if (state.filters.tasks.company && state.filters.tasks.company.length > 0) {
        q.parameter.whereSentToOrganizationIdList = state.filters.tasks.company
    } else {
        q.parameter.whereSentToOrganizationIdList = null
    }

    // Start date
    if (filter.whereAfterStartDate) {
        const afterStartDate = new Date(filter.whereAfterStartDate)
        q.parameter.whereAfterStartDate = new Date(afterStartDate.setHours(1, 0, 0)).toISOString()
    } else if (state.filters.tasks.startDate.from) {
        q.parameter.whereAfterStartDate = state.filters.tasks.startDate.from
    } else {
        q.parameter.whereAfterStartDate = null
    }

    // End date
    if (filter.whereBeforeLatestDate) {
        const beforeLatestDate = new Date(filter.whereBeforeLatestDate)
        q.parameter.whereBeforeLatestDate = new Date(beforeLatestDate.setHours(23, 59, 59)).toISOString()
    } else if (state.filters.tasks.startDate.to) {
        q.parameter.whereBeforeLatestDate = state.filters.tasks.startDate.to
    } else {
        q.parameter.whereBeforeLatestDate = null
    }

    // Ready for approval
    if (filter.whereReadyForApproval) {
        q.parameter.whereReadyForApproval = filter.whereReadyForApproval
    } else if (state.filters.tasks.showReadyForApproval) {
        q.parameter.whereReadyForApproval = state.filters.tasks.showReadyForApproval
    }

    // SerialNumber
    if (filter.whereSerialNumber) {
        q.parameter.whereSerialNumber = filter.whereSerialNumber
    } else if (state.filters.tasks.requisitionsSerialNumber) {
        q.parameter.whereSerialNumber = state.filters.tasks.requisitionsSerialNumber
    } else {
        q.parameter.whereSerialNumber = null
    }

    return q
}

function advancedRequisitionQuery (q, filter, state) {
    state.activePages.requisitions = filter.pageNumber || 1
    q.pageNumber = filter.pageNumber || 1
    q.orderByColumnName = filter.orderByColumnName || state.currentRequisitionOrderByColumnName
    q.orderByDescending = filter.orderByDescending || state.currentRequisitionOrderByDescending

    // Task name
    if (filter.whereLikeTaskName) {
        q.parameter.whereLikeTaskName = filter.whereLikeTaskName
    } else if (state.filters.requisitions.name) {
        q.parameter.whereLikeTaskName = state.filters.requisitions.name
    } else {
        q.parameter.whereLikeTaskName = null
    }

    // Address
    if (filter.whereLikeAddress) {
        q.parameter.whereLikeAddress = filter.whereLikeAddress
    } else if (state.filters.address) {
        q.parameter.whereLikeAddress = state.filters.address
    } else {
        q.parameter.whereLikeAddress = null
    }

    // Responsible
    if (filter.whereOwnerUserIdList) {
        q.parameter.whereOwnerUserIdList = filter.whereOwnerUserIdList.length === 0 ? null : filter.whereOwnerUserIdList
    } else if (state.filters.requisitions.responsible && state.filters.requisitions.responsible.length > 0 && window.innerWidth > 650) {
        q.parameter.whereOwnerUserIdList = state.filters.requisitions.responsible
    } else {
        q.parameter.whereOwnerUserIdList = null
    }

    // Sent to user
    if (filter.whereSentToUserIdList) {
        q.parameter.whereSentToUserIdList = filter.whereSentToUserIdList.length === 0 ? null : filter.whereSentToUserIdList
    } else if (state.filters.requisitions.contact && state.filters.requisitions.contact.length > 0) {
        q.parameter.whereSentToUserIdList = state.filters.requisitions.contact
    } else {
        q.parameter.whereSentToUserIdList = null
    }

    // Sent to organization
    if (filter.whereSentToOrganizationIdList) {
        q.parameter.whereSentToOrganizationIdList = filter.whereSentToOrganizationIdList.length === 0 ? null : filter.whereSentToOrganizationIdList
    } else if (state.filters.requisitions.company && state.filters.requisitions.company.length > 0) {
        q.parameter.whereSentToOrganizationIdList = state.filters.requisitions.company
    } else {
        q.parameter.whereSentToOrganizationIdList = null
    }

    // Activity type
    if (filter.whereActivityTypeIdList) {
        q.parameter.whereActivityTypeIdList = filter.whereActivityTypeIdList.length === 0 ? null : filter.whereActivityTypeIdList
    } else if (state.filters.requisitions.activityType && state.filters.requisitions.activityType.length > 0) {
        q.parameter.whereActivityTypeIdList = state.filters.requisitions.activityType
    } else {
        q.parameter.whereActivityTypeIdList = null
    }

    // Start date
    if (filter.whereAfterStartDate) {
        const afterStartDate = new Date(filter.whereAfterStartDate)
        q.parameter.whereAfterStartDate = new Date(afterStartDate.setHours(1, 0, 0)).toISOString()
    } else if (state.filters.requisitions.startDate.from) {
        q.parameter.whereAfterStartDate = state.filters.requisitions.startDate.from
    } else {
        q.parameter.whereAfterStartDate = null
    }

    // End date
    if (filter.whereBeforeLatestDate) {
        const beforeLatestDate = new Date(filter.whereBeforeLatestDate)
        q.parameter.whereBeforeLatestDate = new Date(beforeLatestDate.setHours(23, 59, 59)).toISOString()
    } else if (state.filters.requisitions.startDate.to) {
        q.parameter.whereBeforeLatestDate = state.filters.requisitions.startDate.to
    } else {
        q.parameter.whereBeforeLatestDate = null
    }

    // Overdue
    q.parameter.whereOverdue = filter.whereOverdue || state.filters.requisitions.dateOverdue

    // Status
    if (filter.whereRequisitionAndReportStatusList) {
        q.parameter.whereRequisitionAndReportStatusList = filter.whereRequisitionAndReportStatusList.length === 0 ? null : filter.whereRequisitionAndReportStatusList
    } else if (state.filters.requisitions.statusType && state.filters.requisitions.statusType.length > 0) {
        q.parameter.whereRequisitionAndReportStatusList = state.filters.requisitions.statusType
    } else {
        q.parameter.whereRequisitionAndReportStatusList = null
    }

    // Approved
    q.parameter.whereReportIsApproved = filter.whereReportIsApproved || state.filters.requisitions.showApproved

    // SerialNumber
    if (filter.whereSerialNumber) {
        q.parameter.whereSerialNumber = filter.whereSerialNumber
    } else if (state.filters.requisitions.serialNumber) {
        q.parameter.whereSerialNumber = state.filters.requisitions.serialNumber
    } else {
        q.parameter.whereSerialNumber = null
    }

    return q
}

function advancedRoutineQuery (q, filter, state) {
    state.activePages.routines = filter.pageNumber || 1
    q.pageNumber = filter.pageNumber || 1
    q.orderByColumnName = filter.orderByColumnName || state.currentRoutineOrderByColumnName
    q.orderByDescending = filter.orderByDescending || state.currentRoutineOrderByDescending

    // Name
    if (filter.whereLikeTaskName) {
        q.parameter.whereLikeTaskName = filter.whereLikeTaskName
    } else if (state.filters.routines.name) {
        q.parameter.whereLikeTaskName = state.filters.routines.name
    } else {
        q.parameter.whereLikeTaskName = null
    }

    // Address
    if (filter.whereLikeAddress) {
        q.parameter.whereLikeAddress = filter.whereLikeAddress
    } else if (state.filters.address) {
        q.parameter.whereLikeAddress = state.filters.address
    } else {
        q.parameter.whereLikeAddress = null
    }

    // Responsible
    if (filter.whereOwnerUserIdList) {
        q.parameter.whereOwnerUserIdList = filter.whereOwnerUserIdList.length === 0 ? null : filter.whereOwnerUserIdList
    } else if (state.filters.routines.responsible && state.filters.routines.responsible.length > 0) {
        q.parameter.whereOwnerUserIdList = state.filters.routines.responsible
    } else {
        q.parameter.whereOwnerUserIdList = null
    }

    // Closed
    q.parameter.whereIsClosed = filter.whereIsClosed || state.filters.routines.showClosed

    // Sent to organization
    if (filter.whereSentToOrganizationIdList) {
        q.parameter.whereSentToOrganizationIdList = filter.whereSentToOrganizationIdList.length === 0 ? null : filter.whereSentToOrganizationIdList
    } else if (state.filters.routines.company && state.filters.routines.company.length > 0) {
        q.parameter.whereSentToOrganizationIdList = state.filters.routines.company
    } else {
        q.parameter.whereSentToOrganizationIdList = null
    }

    return q
}

function advancedTemplateQuery (q, filter, state) {
    state.activePages.templates = filter.pageNumber || 1
    q.pageNumber = filter.pageNumber || 1
    q.orderByColumnName = filter.orderByColumnName || state.currentTemplateOrderByColumnName
    q.orderByDescending = filter.orderByDescending || state.currentTemplateOrderByDescending

    // Name
    if (filter.whereLikeTaskName) {
        q.parameter.whereLikeTaskName = filter.whereLikeTaskName
    } else if (state.filters.templates.name) {
        q.parameter.whereLikeTaskName = state.filters.templates.name
    } else {
        q.parameter.whereLikeTaskName = null
    }

    return q
}

const state = {
    tabs: [],
    activePages: {
        enquiries: 1,
        tasks: 1,
        requisitions: 1,
        routines: 1,
        templates: 1,
        tasksSimple: 1
    },
    selectedTab: '',
    businessAreaTypes: [],
    request: [],
    requestLoading: false,
    task: [],
    taskLoading: false,
    requisition: [],
    requisitionMapItems: [],
    requisitionLoading: false,
    routine: [],
    routineLoading: false,
    template: [],
    templateLoading: false,
    taskSimple: [],
    enquiryTask: [],
    kpi: [],
    advancedFilterTaskEnquiry: {
        whereCurrentLocationPointWkt: null,
        whereDistanceWithinFromRequestId: null,
        whereCurrentLocationWithinDistance: null
    },
    firstTimeLogIn: true,
    circleAnimation: false,
    currentEnquiryOrderByColumnName: 'occurrenceDateTime',
    currentEnquiryOrderByDescending: true,
    currentTaskOrderByColumnName: 'updated',
    currentTaskOrderByDescending: true,
    currentTaskSimpleOrderByColumnName: 'updated',
    currentTaskSimpleOrderByDescending: false,
    currentRequisitionOrderByColumnName: 'status',
    currentRequisitionOrderByDescending: false,
    currentRoutineOrderByColumnName: 'nextDate',
    currentRoutineOrderByDescending: false,
    currentTemplateOrderByColumnName: 'name',
    currentTemplateOrderByDescending: false,
    pageSize: 20,
    activePageContextView: 1,
    enquiryFilter: null,
    taskFilter: null,
    requisitionFilter: null,
    routineFilter: null,
    templateFilter: false,

    filters: {
        enquiries: {
            showClosed: false,
            responsible: [],
            createdDate: {
                from: null,
                to: null
            },
            problemType: [],
            contactType: []
        },
        tasks: {
            name: null,
            responsible: [],
            showClosed: false,
            contact: [],
            company: [],
            requisitionsSerialNumber: null,
            startDate: {
                from: null,
                to: null
            },
            showReadyForApproval: false
        },
        requisitions: {
            name: null,
            responsible: [],
            contact: [],
            company: [],
            activityType: [],
            startDate: {
                from: null,
                to: null
            },
            dateOverdue: false,
            statusType: [],
            showApproved: false,
            serialNumber: null
        },
        routines: {
            name: null,
            responsible: [],
            showClosed: false,
            company: []
        },
        templates: {
            name: null
        },

        kpi: null,
        supplyType: [],
        address: null
    }
}

const getters = {
    getBusinessAreaTypes: state => {
        return state.businessAreaTypes
    },
    getTabs: state => {
        return state.tabs
    },
    getActivePages: state => {
        return state.activePages
    },
    getSelectedTab: state => {
        return state.selectedTab
    },
    getRequestList: state => {
        return state.request
    },
    getEnquiriesLoading: state => {
        return state.requestLoading
    },
    getTaskList: state => {
        return state.task
    },
    getTaskLoading: state => {
        return state.taskLoading
    },
    getRequisitionList: state => {
        return state.requisition
    },
    getRequisitionMapItems: state => {
        return state.requisitionMapItems
    },
    getRequisitionLoading: state => {
        return state.requisitionLoading
    },
    getRoutineList: state => {
        return state.routine
    },
    getRoutineLoading: state => {
        return state.routineLoading
    },
    getTemplateList: state => {
        return state.template
    },
    getTemplateLoading: state => {
        return state.templateLoading
    },
    getTaskSimple: state => {
        return state.taskSimple
    },
    getEnquiryTask: state => {
        return state.enquiryTask
    },
    getKPI: state => {
        return state.kpi
    },
    firstTimeLogIn: state => {
        return state.firstTimeLogIn
    },
    getCircleAnimation: state => {
        return state.circleAnimation
    },
    getCurrentEnquiryOrderByColumnName: state => {
        return state.currentEnquiryOrderByColumnName
    },
    getCurrentEnquiryOrderByDescending: state => {
        return state.currentEnquiryOrderByDescending
    },
    getCurrentTaskOrderByColumnName: state => {
        return state.currentTaskOrderByColumnName
    },
    getCurrentTaskOrderByDescending: state => {
        return state.currentTaskOrderByDescending
    },
    getCurrentTaskSimpleOrderByColumnName: state => {
        return state.currentTaskSimpleOrderByColumnName
    },
    getCurrentTaskSimpleOrderByDescending: state => {
        return state.currentTaskSimpleOrderByDescending
    },
    getCurrentRequisitionOrderByColumnName: state => {
        return state.currentRequisitionOrderByColumnName
    },
    getCurrentRequisitionOrderByDescending: state => {
        return state.currentRequisitionOrderByDescending
    },
    getCurrentRoutineOrderByColumnName: state => {
        return state.currentRoutineOrderByColumnName
    },
    getCurrentRoutineOrderByDescending: state => {
        return state.currentRoutineOrderByDescending
    },
    getCurrentTemplateOrderByColumnName: state => {
        return state.currentTemplateOrderByColumnName
    },
    getCurrentTemplateOrderByDescending: state => {
        return state.currentTemplateOrderByDescending
    },
    getPageSize: state => {
        return state.pageSize
    },

    getFilters: state => {
        return state.filters
    }
}

const mutations = {
    setTabs: (state, payload) => {
        let tabPermissions = {}
        state.tabs = []

        // Filtrerer ikke-nødvendige permissions fra
        tabPermissions.requests = payload.requests
        tabPermissions.tasks = payload.tasks
        tabPermissions.requisitions = payload.requisitions

        if (tabPermissions.tasks.enabled) {
            tabPermissions.routines = {
                enabled: true
            }
            tabPermissions.templates = {
                enabled: true
            }
        } else {
            tabPermissions.routines = {
                enabled: false
            }
            tabPermissions.templates = {
                enabled: false
            }
        }
        for (let i in tabPermissions) {
            if (tabPermissions[i].enabled) {
                let object = {
                    name: i
                }
                state.tabs.push(object)
            }
        }

        // We want the selected tab to be requisitions when you dont have acces to enquiries but have acces to tasks and requisitions
        if (tabPermissions.tasks.enabled || tabPermissions.requisitions.enabled) {
            if (tabPermissions.requisitions.enabled) {
                if (state.tabs.filter(tab => tab.name === 'requisitions').length > 0) {
                    state.selectedTab = state.tabs.filter(tab => tab.name === 'requisitions')[0].name
                }
            } else if (tabPermissions.tasks.enabled) {
                if (state.tabs.filter(tab => tab.name === 'tasks').length > 0) {
                    state.selectedTab = state.tabs.filter(tab => tab.name === 'tasks')[0].name
                }
            }
        } else if (tabPermissions.requests.enabled) {
            if (state.tabs.filter(tab => tab.name === 'requests').length > 0) {
                state.selectedTab = state.tabs.filter(tab => tab.name === 'requests')[0].name
            }
        } else {
            console.log('No views avaible')
        }

        if (state.selectedTab === 'requisitions' && tabPermissions.requests.enabled && payload.isDesktop !== undefined) {
            if (payload.isDesktop === true) {
                state.selectedTab = state.tabs.filter(tab => tab.name === 'requests')[0].name
            }
        }
    },
    setActivePages: (state, payload) => {
        state.activePages[payload.tab] = payload.page || state.activePages[payload.tab]
    },
    setSelectedTab: (state, payload) => {
        state.activePages = {
            enquiries: 1,
            tasks: 1,
            requisitions: 1,
            routines: 1,
            templates: 1,
            tasksSimple: 1
        }
        state.selectedTab = payload
    },
    addBusinessAreaTypes: (state, payload) => {
        for (let i in payload) {
            payload[i].systemName = payload[i].systemName.toLowerCase()
        }
        state.businessAreaTypes = payload
    },
    setEnquiryList: (state, payload) => {
        state.request = payload
    },
    setTaskList: (state, payload) => {
        state.task = payload
    },
    setRequisitionList: (state, payload) => {
        state.requisition = payload
    },
    setRequisitionMapItems: (state, payload) => {
        state.requisitionMapItems = payload
    },
    setRoutineList: (state, payload) => {
        state.routine = payload
    },
    setTemplateList: (state, payload) => {
        state.template = payload
    },
    setTaskListSimple: (state, payload) => {
        state.taskSimple = payload
    },
    addSelectedCaseworker: (state, payload) => {
        if (payload === undefined) {
            state.selectedCaseworker = 'Alle'
        }
        state.selectedCaseworker = payload
    },
    addEnquiryTask: (state, payload) => {
        state.enquiryTask = []

        if (payload) {
            state.enquiryTask.push(payload)
        }
    },
    setKPI: (state, payload) => {
        state.kpi = payload
    },
    setFirstTimeLogIn: (state, payload) => {
        state.firstTimeLogIn = payload
    },
    setCircleAnimation: (state, payload) => {
        state.circleAnimation = payload
    },
    setCurrentEnquiryOrderByDescending: (state, payload) => {
        if (payload !== undefined) {
            state.currentEnquiryOrderByDescending = payload
        }
    },
    setCurrentEnquiryOrderByColumnName: (state, payload) => {
        if (payload !== undefined) {
            state.currentEnquiryOrderByColumnName = payload
        }
    },
    setCurrentTaskOrderByDescending: (state, payload) => {
        if (payload !== undefined) {
            state.currentTaskOrderByDescending = payload
        }
    },
    setCurrentTaskOrderByColumnName: (state, payload) => {
        if (payload !== undefined) {
            state.currentTaskOrderByColumnName = payload
        }
    },
    setCurrentTaskSimpleOrderByDescending: (state, payload) => {
        if (payload !== undefined) {
            state.currentTaskSimpleOrderByDescending = payload
        }
    },
    setCurrentTaskSimpleOrderByColumnName: (state, payload) => {
        if (payload !== undefined) {
            state.currentTaskSimpleOrderByColumnName = payload
        }
    },
    setCurrentRoutineOrderByDescending: (state, payload) => {
        if (payload !== undefined) {
            state.currentRoutineOrderByDescending = payload
        }
    },
    setCurrentRoutineOrderByColumnName: (state, payload) => {
        if (payload !== undefined) {
            state.currentRoutineOrderByColumnName = payload
        }
    },
    setCurrentTemplateOrderByDescending: (state, payload) => {
        if (payload !== undefined) {
            state.currentTemplateOrderByDescending = payload
        }
    },
    setCurrentTemplateOrderByColumnName: (state, payload) => {
        if (payload !== undefined) {
            state.currentTemplateOrderByColumnName = payload
        }
    },
    setCurrentRequisitionOrderByDescending: (state, payload) => {
        if (payload !== undefined) {
            state.currentRequisitionOrderByDescending = payload
        }
    },
    setCurrentRequisitionOrderByColumnName: (state, payload) => {
        if (payload !== undefined) {
            state.currentRequisitionOrderByColumnName = payload
        }
    },
    setActivePageContextView: (state, payload) => {
        state.activePageContextView = payload
    },

    setFilters: (state, payload) => {
        if (payload.filter !== 'kpi') {
            state.filters.kpi = null
        }
        if (payload.page && payload.filter) {
            if (state.filters[payload.page][payload.filter] instanceof Array) {
                // Responsible, Problem type, Contact type, Company, Contact, Activity type
                if (!state.filters[payload.page][payload.filter].includes(payload.value)) {
                    state.filters[payload.page][payload.filter].push(payload.value)
                }
            } else {
                // Task name, Requisition task name, Routine name
                state.filters[payload.page][payload.filter] = payload.value
            }
        } else if (payload.filter) {
            if (state.filters[payload.filter] instanceof Array) {
                // Supply type
                if (!state.filters[payload.filter].includes(payload.value)) {
                    state.filters[payload.filter].push(payload.value)
                }
            } else {
                // Address
                state.filters[payload.filter] = payload.value
            }
        }
        if (state.selectedTab === 'requisitions' && payload.custom) {
            state.filters.requisitions.contact = null
            state.filters.requisitions.company = null
        }
    },
    removeFilters: (state, payload) => {
        if (payload.page && payload.filter) {
            if (state.filters[payload.page][payload.filter] instanceof Array) {
                // Responsible, Problem type, Contact type, Company, Contact, Activity type
                state.filters[payload.page][payload.filter] = state.filters[payload.page][payload.filter].filter(item => item !== payload.value)
            } else if (state.filters[payload.page][payload.filter] instanceof Object && payload.value instanceof Date) {
                state.filters[payload.page][payload.filter].from = null
                state.filters[payload.page][payload.filter].to = null
            } else if (state.filters[payload.page][payload.filter] instanceof Object) {
                console.log('This filter is a Object but not with Dates')
                // Would this ever happen?
            } else if (typeof state.filters[payload.page][payload.filter] === 'string') {
                state.filters[payload.page][payload.filter] = ''
            } else if (typeof state.filters[payload.page][payload.filter] === 'boolean') {
                state.filters[payload.page][payload.filter] = false
            }
        } else if (payload.filter) {
            if (state.filters[payload.filter] instanceof Array) {
                // Supply type
                state.filters[payload.filter] = state.filters[payload.filter].filter(item => item !== payload.value)
            } else {
                // Address
                state.filters[payload.filter] = payload.value
            }
        }
    }
}

const actions = {
    setSelectedTab: ({ commit }, name) => {
        commit('setSelectedTab', name)
    },
    setBusinessAreaTypes: ({ commit }, businessAreaTypes) => {
        commit('addBusinessAreaTypes', businessAreaTypes)
    },
    /* Henvendelser */
    getQueryRequestList: ({ commit, rootState }, filter) => {
        if (rootState.global.userInfo.permissions.requests.enabled) {
            state.requestLoading = true

            const timeStart = new Date()
            let query = setSearchParameters(filter, 'request', state, rootState)

            state.enquiryFilter = query

            return axios.post('/Query/QueryRequestList', query)
                .then((response) => {
                    commit('setEnquiryList', response.data)
                    commit('successHandler', response)

                    const timeNow = new Date()
                    const timeElapsed = timeStart - timeNow

                    setTimeout(() => {
                        state.requestLoading = false
                    }, Math.max(0, 400 + timeElapsed))
                })
                .catch((error) => {
                    let errorMessage = error.message

                    if (error.response && error.response.data && error.response.data.Message && error.response.data.Message) {
                        errorMessage = error.response.data.Message
                    }
                    commit('errorHandler', errorMessage)

                    throw error
                })
        }
    },
    saveQueryRequestFiltering: ({ commit, rootState }, filter) => {
        if (rootState.global.userInfo.permissions.requests.enabled) {
            let query = setSearchParameters(filter, 'request', state, rootState)

            state.enquiryFilter = query

            return axios.post('/Query/QueryRequestList', query)
                .then(() => {
                })
                .catch((error) => {
                    let errorMessage = error.message

                    if (error.response && error.response.data && error.response.data.Message && error.response.data.Message) {
                        errorMessage = error.response.data.Message
                    }
                    commit('errorHandler', errorMessage)

                    throw error
                })
        }
    },
    /* Opgaver */
    getQueryTaskList ({ commit, rootState }, filter) {
        if (rootState.global.userInfo.permissions.tasks.enabled) {
            state.taskLoading = true
            const timeStart = new Date()
            let query = setSearchParameters(filter, 'task', state, rootState)

            state.taskFilter = query

            return axios.post('/Query/QueryTaskList', query)
                .then((response) => {
                    commit('setTaskList', response.data)
                    commit('successHandler', response)

                    const timeNow = new Date()
                    const timeElapsed = timeStart - timeNow

                    setTimeout(() => {
                        state.taskLoading = false
                    }, Math.max(0, 400 + timeElapsed))
                })
                .catch((error) => {
                    let errorMessage = error.message

                    if (error.response && error.response.data && error.response.data.Message && error.response.data.Message) {
                        errorMessage = error.response.data.Message
                    }
                    commit('errorHandler', errorMessage)

                    throw error
                })
        }
    },
    saveQueryTaskFiltering ({ commit, rootState }, filter) {
        if (rootState.global.userInfo.permissions.tasks.enabled) {
            let query = setSearchParameters(filter, 'task', state, rootState)

            state.taskFilter = query

            return axios.post('/Query/QueryTaskList', query)
                .then(() => {
                })
                .catch((error) => {
                    let errorMessage = error.message

                    if (error.response && error.response.data && error.response.data.Message && error.response.data.Message) {
                        errorMessage = error.response.data.Message
                    }
                    commit('errorHandler', errorMessage)

                    throw error
                })
        }
    },
    /* Entreprenøropgaver */
    getQueryRequisitionList: ({ commit, rootState }, filter) => {
        if (rootState.global.userInfo.permissions.requisitions.enabled) {
            state.requisitionLoading = true
            const timeStart = new Date()
            let query = setSearchParameters(filter, 'requisition', state, rootState)
            query.mapItems = filter.showMap
            state.requisitionFilter = query
            return axios.post('/Query/QueryRequisitionList', query)
                .then((response) => {
                    commit('setRequisitionList', response.data.requisitions)
                    commit('setRequisitionMapItems', response.data.requisitionMapItems)
                    commit('successHandler', response)

                    const timeNow = new Date()
                    const timeElapsed = timeStart - timeNow

                    setTimeout(() => {
                        state.requisitionLoading = false
                    }, Math.max(0, 400 + timeElapsed))
                })
                .catch((error) => {
                    let errorMessage = error.message

                    if (error.response && error.response.data && error.response.data.Message && error.response.data.Message) {
                        errorMessage = error.response.data.Message
                    }
                    commit('errorHandler', errorMessage)

                    throw error
                })
        }
    },
    saveQueryRequisitionFiltering: ({ commit, rootState }, filter) => {
        if (rootState.global.userInfo.permissions.requisitions.enabled) {
            let query = setSearchParameters(filter, 'requisition', state, rootState)

            state.requisitionFilter = query

            return axios.post('/Query/QueryRequisitionList', query)
                .then(() => {
                })
                .catch((error) => {
                    let errorMessage = error.message

                    if (error.response && error.response.data && error.response.data.Message && error.response.data.Message) {
                        errorMessage = error.response.data.Message
                    }
                    commit('errorHandler', errorMessage)

                    throw error
                })
        }
    },
    /* Rutiner */
    getQueryRoutineList: ({ commit, rootState }, filter) => {
        state.routineLoading = true

        const timeStart = new Date()
        let query = setSearchParameters(filter, 'routine', state, rootState)

        state.routineFilter = query

        return axios.post('/Query/QueryTaskWithRoutineList', query)
            .then((response) => {
                commit('setRoutineList', response.data)
                commit('successHandler', response)

                const timeNow = new Date()
                const timeElapsed = timeStart - timeNow

                setTimeout(() => {
                    state.routineLoading = false
                }, Math.max(0, 400 + timeElapsed))
            })
            .catch((error) => {
                let errorMessage = error.message

                if (error.response && error.response.data && error.response.data.Message && error.response.data.Message) {
                    errorMessage = error.response.data.Message
                }
                commit('errorHandler', errorMessage)

                throw error
            })
    },
    saveQueryRoutineFiltering: ({ commit, rootState }, filter) => {
        let query = setSearchParameters(filter, 'routine', state, rootState)

        state.routineFilter = query

        return axios.post('/Query/QueryTaskWithRoutineList', query)
            .then(() => {
            })
            .catch((error) => {
                let errorMessage = error.message

                if (error.response && error.response.data && error.response.data.Message && error.response.data.Message) {
                    errorMessage = error.response.data.Message
                }
                commit('errorHandler', errorMessage)

                throw error
            })
    },
    /* Skabeloner */
    getQueryTemplateList: ({ commit, rootState }, filter) => {
        state.templateLoading = true

        const timeStart = new Date()
        let query = setSearchParameters(filter, 'template', state, rootState)

        state.templateFilter = query

        return axios.post('/Query/QueryTaskTemplateList', query)
            .then((response) => {
                commit('setTemplateList', response.data)
                commit('successHandler', response)

                const timeNow = new Date()
                const timeElapsed = timeStart - timeNow

                setTimeout(() => {
                    state.templateLoading = false
                }, Math.max(0, 400 + timeElapsed))
            })
            .catch((error) => {
                let errorMessage = error.message

                if (error.response && error.response.data && error.response.data.Message && error.response.data.Message) {
                    errorMessage = error.response.data.Message
                }
                commit('errorHandler', errorMessage)

                throw error
            })
    },
    saveQueryTemplateFiltering: ({ commit, rootState }, filter) => {
        let query = setSearchParameters(filter, 'template', state, rootState)

        state.templateFilter = query

        return axios.post('/Query/QueryTaskTemplateList', query)
            .then(() => {
            })
            .catch((error) => {
                let errorMessage = error.message

                if (error.response && error.response.data && error.response.data.Message && error.response.data.Message) {
                    errorMessage = error.response.data.Message
                }
                commit('errorHandler', errorMessage)

                throw error
            })
    },
    // Tasks, requisitions and routines
    getQueryTaskListFromEnquiry: ({ commit, rootState }, filter) => {
        if (rootState.global.userInfo.permissions.tasks.enabled) {
            let query = setSearchParameters(filter, 'taskEnquiry', state, rootState)

            return axios.post('/Query/QueryTaskList', query)
                .then((response) => {
                    return new Promise((resolve, reject) => {
                        if (filter.whereTaskId) {
                            commit('addEnquiryTask', response.data[0])
                        } else {
                            commit('addEnquiryTask')
                            commit('setTaskListSimple', response.data)
                        }
                        resolve(response.data)
                    })
                })
                .catch((error) => {
                    let errorMessage = error.message

                    if (error.response && error.response.data && error.response.data.Message && error.response.data.Message) {
                        errorMessage = error.response.data.Message
                    }
                    commit('errorHandler', errorMessage)

                    throw error
                })
        }
    },
    setEnquiryTask: ({ commit }, taskId) => {
        if (!taskId) {
            commit('addEnquiryTask')
        }
        for (let i in state.taskSimple) {
            if (state.taskSimple[i].taskId === taskId) {
                commit('addEnquiryTask', state.taskSimple[i])
            }
        }
    },
    setKPI: ({ commit, rootState }, userId) => {
        return axios.post('/Query/QueryCounts').then((response) => {
            let activeKPIs = []
            for (let i in response.data) {
                if (response.data[i].customFilter) {
                    activeKPIs.push(response.data[i])
                } else if (response.data[i].filter === 'noCaseWorker' || response.data[i].filter === 'approveReady' || response.data[i].filter === 'requisitionsOverdue' || response.data[i].filter === 'overdue' || response.data[i].filter === 'notClosed') {
                    let category = response.data[i].category
                    if (rootState.global.userInfo.permissions[category] && rootState.global.userInfo.permissions[category].enabled) {
                        if (rootState.global.userInfo.permissions.kpi && rootState.global.userInfo.permissions.kpi.contractorEnabled && !rootState.global.userInfo.permissions.kpi.caseOwnerEnabled) {
                            if (response.data[i].filter !== 'overdue') {
                                activeKPIs.push(response.data[i])
                            }
                        } else {
                            activeKPIs.push(response.data[i])
                        }
                    }
                }
            }
            commit('setKPI', activeKPIs)
        }, (response) => {
            commit('errorHandler', response)
        })
    },
    setFirstTimeLogIn: ({ commit }, boolean) => {
        commit('setFirstTimeLogIn', boolean)
    },
    exportToExcel: ({ commit }, payload) => {
        let filterObj = {}

        if (payload.type === 'requests') {
            filterObj = state.enquiryFilter
        } else if (payload.type === 'tasks') {
            filterObj = state.taskFilter
        } else if (payload.type === 'requisitions' || payload.type === 'requisitions_objects') {
            filterObj = state.requisitionFilter
        } else if (payload.type === 'routines') {
            filterObj = state.routineFilter
        }
        filterObj.type = payload.type

        return axios.downloadExcel('/Query/ExportToExcel', filterObj)
            .then((response) => {
                return new Promise((resolve, reject) => {
                    let blob = new Blob([response.data], { type: 'application/vnd.ms-excel' })

                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(blob, payload.type + '.xlsx')
                        resolve(blob)
                    }

                    const data = window.URL.createObjectURL(blob)
                    var link = document.createElement('a')

                    link.href = data
                    link.download = payload.type + '.xlsx'
                    link.click()

                    resolve(blob)
                })
            }, (response) => {
                commit('errorHandler', response)
            })
    },
    startCircleAnimation: ({ commit }, boolean) => {
        commit('setCircleAnimation', boolean)
    },
    setActivePages: ({ commit, dispatch, rootState }, payload) => {
        if (payload.tab === 'requests' || payload.tab === 'enquiries') {
            state.request = null
            commit('setCurrentEnquiryOrderByColumnName', payload.orderByColumnName)
            commit('setCurrentEnquiryOrderByDescending', payload.orderByDescending)
            dispatch('getQueryRequestList', {
                pageNumber: payload.page,
                orderByColumnName: payload.orderByColumnName,
                orderByDescending: payload.orderByDescending
            })
        } else if (payload.tab === 'tasks') {
            state.task = null
            commit('setCurrentTaskOrderByColumnName', payload.orderByColumnName)
            commit('setCurrentTaskOrderByDescending', payload.orderByDescending)
            dispatch('getQueryTaskList', {pageNumber: payload.page, orderByColumnName: payload.orderByColumnName, orderByDescending: payload.orderByDescending, whereBusinessAreaTypeIdList: payload.whereBusinessAreaTypeIdList, whereOwnerUserIdList: payload.whereOwnerUserIdList})
        } else if (payload.tab === 'requisitions') {
            state.requisition = null
            commit('setCurrentRequisitionOrderByColumnName', payload.orderByColumnName)
            commit('setCurrentRequisitionOrderByDescending', payload.orderByDescending)
            if (rootState.global.userInfo.permissions.requisitions.enabled) {
                dispatch('getQueryRequisitionList', {pageNumber: payload.page, orderByColumnName: payload.orderByColumnName, orderByDescending: payload.orderByDescending, whereBusinessAreaTypeIdList: payload.whereBusinessAreaTypeIdList, whereOwnerUserIdList: payload.whereOwnerUserIdList, firmId: payload.firmId, userId: payload.userId, whereReportIsApproved: payload.whereReportIsApproved})
            }
        } else if (payload.tab === 'routines') {
            state.routine = null
            commit('setCurrentRoutineOrderByColumnName', payload.orderByColumnName)
            commit('setCurrentRoutineOrderByDescending', payload.orderByDescending)
            dispatch('getQueryRoutineList', {pageNumber: payload.page, orderByColumnName: payload.orderByColumnName, orderByDescending: payload.orderByDescending, whereBusinessAreaTypeIdList: payload.whereBusinessAreaTypeIdList, whereOwnerUserIdList: payload.whereOwnerUserIdList})
        } else if (payload.tab === 'templates') {
            state.template = null
            commit('setCurrentTemplateOrderByColumnName', payload.orderByColumnName)
            commit('setCurrentTemplateOrderByDescending', payload.orderByDescending)
            dispatch('getQueryTemplateList', {pageNumber: payload.page, orderByColumnName: payload.orderByColumnName, orderByDescending: payload.orderByDescending, whereOwnerUserIdList: payload.whereOwnerUserIdList})
        } else if (payload.tab === 'tasks-simple') {
            state.taskSimple = null
            commit('setCurrentTaskSimpleOrderByColumnName', payload.orderByColumnName)
            commit('setCurrentTaskSimpleOrderByDescending', payload.orderByDescending)
            dispatch('getQueryTaskListFromEnquiry', {pageNumber: payload.page, whereTaskId: payload.whereTaskId, orderByColumnName: payload.orderByColumnName, orderByDescending: payload.orderByDescending})
        }

        commit('setActivePages', payload)
    },
    setActivePageContextView: ({ commit }, payload) => {
        commit('setActivePageContextView', payload)
    },

    setFilters: ({ commit }, payload) => {
        commit('setFilters', payload)
    },
    removeFilters: ({ commit }, payload) => {
        commit('removeFilters', payload)
    },
    setCustomFilter ({ commit, dispatch }, payload) {
        const filtering = payload
        // Supply type
        if (filtering.parameterList.WhereBusinessAreaTypeIdList) {
            state.filters.supplyType = filtering.parameterList.WhereBusinessAreaTypeIdList
        }
        if (filtering.type === 'request') {
            // Address
            if (filtering.parameterList.WhereLikeOccurrenceAddress) {
                state.filters.address = filtering.parameterList.WhereLikeOccurrenceAddress
            }

            // Closed
            if (filtering.parameterList.WhereIsClosed) {
                state.filters.enquiries.showClosed = filtering.parameterList.WhereIsClosed
            }
            // Responsible
            if (filtering.parameterList.WhereOwnerUserIdList) {
                state.filters.enquiries.responsible = filtering.parameterList.WhereOwnerUserIdList
            }
            // From date
            if (filtering.parameterList.WhereFromDate) {
                state.filters.enquiries.createdDate.from = new Date(filtering.parameterList.WhereFromDate)
            }
            // To date
            if (filtering.parameterList.WhereToDate) {
                state.filters.enquiries.createdDate.to = new Date(filtering.parameterList.WhereToDate)
            }
            // Problem type
            if (filtering.parameterList.WhereProblemTypeIdList) {
                state.filters.enquiries.problemType = filtering.parameterList.WhereProblemTypeIdList
            }
            // Client type
            if (filtering.parameterList.WhereClientTypeIdList) {
                state.filters.enquiries.contactType = filtering.parameterList.WhereClientTypeIdList
            }
        } else if (filtering.type === 'task') {
            // Name
            if (filtering.parameterList.WhereLikeTaskName) {
                state.filters.tasks.name = filtering.parameterList.WhereLikeTaskName
            }
            // Responsible
            if (filtering.parameterList.WhereOwnerUserIdList) {
                state.filters.tasks.responsible = filtering.parameterList.WhereOwnerUserIdList
            }
            // Closed
            if (filtering.parameterList.WhereIsClosed) {
                state.filters.tasks.showClosed = filtering.parameterList.WhereIsClosed
            }
            // Sent to user
            if (filtering.parameterList.WhereSentToUserIdList) {
                state.filters.tasks.contact = filtering.parameterList.WhereSentToUserIdList
            }
            // Sent to organization
            if (filtering.parameterList.WhereSentToOrganizationIdList) {
                state.filters.tasks.company = filtering.parameterList.WhereSentToOrganizationIdList
            }
            // Start date
            if (filtering.parameterList.WhereAfterStartDate) {
                state.filters.tasks.startDate.from = new Date(filtering.parameterList.WhereAfterStartDate)
            }
            // End date
            if (filtering.parameterList.WhereBeforeLatestDate) {
                state.filters.tasks.startDate.to = new Date(filtering.parameterList.WhereBeforeLatestDate)
            }
            // Ready for approval
            if (filtering.parameterList.WhereReadyForApproval) {
                state.filters.tasks.showReadyForApproval = filtering.parameterList.WhereReadyForApproval
            }
        } else if (filtering.type === 'requisition') {
            // Task name
            if (filtering.parameterList.WhereLikeTaskName) {
                state.filters.requisitions.name = filtering.parameterList.WhereLikeTaskName
            }
            // Responsible
            if (filtering.parameterList.WhereOwnerUserIdList) {
                state.filters.requisitions.responsible = filtering.parameterList.WhereOwnerUserIdList
            }
            // Sent to organization
            if (filtering.parameterList.WhereSentToOrganizationIdList) {
                state.filters.requisitions.company = [filtering.parameterList.WhereSentToOrganizationIdList[filtering.parameterList.WhereSentToOrganizationIdList.length - 1]]
                dispatch('getAssociatedOrganizationUserList', {
                    firmaId: filtering.parameterList.WhereSentToOrganizationIdList[filtering.parameterList.WhereSentToOrganizationIdList.length - 1],
                    supplyType: state.filters.supplyType
                })
            } else {
                state.filters.requisitions.company = null
            }
            // Sent to user
            if (filtering.parameterList.WhereSentToUserIdList) {
                state.filters.requisitions.contact = filtering.parameterList.WhereSentToUserIdList
            } else {
                state.filters.requisitions.contact = null
            }
            // Activity type
            if (filtering.parameterList.WhereActivityTypeIdList) {
                state.filters.requisitions.activityType = filtering.parameterList.WhereActivityTypeIdList
            }
            // Start date
            if (filtering.parameterList.WhereAfterStartDate) {
                state.filters.requisitions.startDate.from = new Date(filtering.parameterList.WhereAfterStartDate)
            }
            // End date
            if (filtering.parameterList.WhereBeforeLatestDate) {
                state.filters.requisitions.startDate.to = new Date(filtering.parameterList.WhereBeforeLatestDate)
            }
            // Overdue
            if (filtering.parameterList.WhereOverdue) {
                state.filters.requisitions.dateOverdue = filtering.parameterList.WhereOverdue
            }
            // Status
            if (filtering.parameterList.WhereRequisitionAndReportStatusList) {
                state.filters.requisitions.statusType = filtering.parameterList.WhereRequisitionAndReportStatusList
            }
            // Approved
            if (filtering.parameterList.WhereReportIsApproved) {
                state.filters.requisitions.showApproved = filtering.parameterList.WhereReportIsApproved
            }
            // SerialNumber
            if (filtering.parameterList.WhereSerialNumber) {
                state.filters.requisitions.serialNumber = filtering.parameterList.WhereSerialNumber
            }
        } else if (filtering.type === 'routine') {
            // Name
            if (filtering.parameterList.WhereLikeTaskName) {
                state.filters.routines.name = filtering.parameterList.WhereLikeTaskName
            }
            // Responsible
            if (filtering.parameterList.WhereOwnerUserIdList) {
                state.filters.routines.responsible = filtering.parameterList.WhereOwnerUserIdList
            }
            // Closed
            if (filtering.parameterList.WhereIsClosed) {
                state.filters.routines.showClosed = filtering.parameterList.WhereIsClosed
            }
            // Sent to organization
            if (filtering.parameterList.WhereSentToUserIdList) {
                state.filters.routines.company = filtering.parameterList.WhereSentToUserIdList
            }
        }
    },
    resetFilters: ({ commit, rootState }, payload) => {
        const supplyTypes = state.businessAreaTypes.map(businessArea => businessArea.sysBusinessAreaTypeId)
        state.activePages = {
            enquiries: 1,
            tasks: 1,
            requisitions: 1,
            routines: 1,
            templates: 1,
            tasksSimple: 1
        }
        if (payload === 'enquiries') {
            state.filters.enquiries = {
                showClosed: false,
                responsible: [],
                createdDate: {
                    from: null,
                    to: null
                },
                problemType: [],
                contactType: []
            }
            state.filters.kpi = null
            state.filters.supplyType = supplyTypes
            state.filters.address = null
        } else if (payload === 'tasks') {
            state.filters.tasks = {
                name: null,
                responsible: [],
                showClosed: false,
                contact: [],
                company: [],
                requisitionsSerialNumber: null,
                startDate: {
                    from: null,
                    to: null
                },
                showReadyForApproval: false
            }
            state.filters.kpi = null
            state.filters.supplyType = supplyTypes
            state.filters.address = null
        } else if (payload === 'requisitions') {
            state.filters.requisitions = {
                name: null,
                responsible: [],
                contact: [],
                company: [],
                activityType: [],
                startDate: {
                    from: null,
                    to: null
                },
                dateOverdue: false,
                statusType: [],
                showApproved: false,
                serialNumber: null
            }
            state.filters.kpi = null
            state.filters.supplyType = supplyTypes
            state.filters.address = null
        } else if (payload === 'routines') {
            state.filters.routines = {
                name: null,
                responsible: [],
                showClosed: false,
                company: []
            }
            state.filters.kpi = null
            state.filters.supplyType = supplyTypes
            state.filters.address = null
        } else if (payload === 'templates') {
            state.filters.templates = {
                name: null
            }
            state.filters.kpi = null
            state.filters.supplyType = supplyTypes
            state.filters.address = null
        } else {
            state.filters = {
                enquiries: {
                    showClosed: false,
                    responsible: [],
                    createdDate: {
                        from: null,
                        to: null
                    },
                    problemType: [],
                    contactType: []
                },
                tasks: {
                    name: null,
                    responsible: [],
                    showClosed: false,
                    contact: [],
                    company: [],
                    requisitionsSerialNumber: null,
                    startDate: {
                        from: null,
                        to: null
                    },
                    showReadyForApproval: false
                },
                requisitions: {
                    name: null,
                    responsible: [],
                    contact: [],
                    company: [],
                    activityType: [],
                    startDate: {
                        from: null,
                        to: null
                    },
                    dateOverdue: false,
                    statusType: [],
                    showApproved: false,
                    serialNumber: null
                },
                routines: {
                    name: null,
                    responsible: [],
                    showClosed: false,
                    company: []
                },
                templates: {
                    name: null
                },

                kpi: null,
                supplyType: supplyTypes,
                address: null
            }
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/dashboard/dashboard.js